import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

/**
 * @component AIInsightError
 * @description Error state for AI insight panel
 * @param {Object} props
 * @param {Object} [props.error] - Error object with code and message
 * @param {Function} [props.onRetry] - Optional retry callback
 * @returns {JSX.Element}
 */
export function AIInsightError({ error, onRetry }) {
  const isInsufficientData = error?.code === 'INSUFFICIENT_DATA';
  const message = isInsufficientData
    ? 'Not enough data for insights'
    : 'Could not generate insight';

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Error content - centered */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          flexGrow: 1,
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: 40,
            color: 'text.disabled',
            mb: 1,
          }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ my: onRetry ? 1 : 0 }}>
          {message}
        </Typography>
        {onRetry && (
          <Button
            variant="outlined"
            size="small"
            onClick={onRetry}
            sx={{ my: 1 }}
          >
            Retry
          </Button>
        )}
      </Box>

      {/* Footer */}
      <Box
        sx={{
          pt: 1.5,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
        }}
      >
        <AutoAwesomeIcon
          sx={{
            fontSize: 14,
            color: 'text.disabled',
          }}
        />
        <Typography
          variant="caption"
          sx={{
            color: 'text.disabled',
            fontSize: '0.7rem',
            fontStyle: 'italic',
          }}
        >
          AI Insights powered by CANai
        </Typography>
      </Box>
    </Paper>
  );
}

